import { render } from "./Frame.vue?vue&type=template&id=f9dd2484&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"

import "./Frame.vue?vue&type=style&index=0&id=f9dd2484&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9dd2484"]])

export default __exports__